import { clearActiveCompany, clearCompanyCache, getActiveCompanyId } from './companyContext';

export const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:3040';

export const broadcastAdminUpdate = (admin) => {
  if (typeof window !== 'undefined' && typeof window.dispatchEvent === 'function') {
    window.dispatchEvent(new CustomEvent('authAdminUpdated', { detail: admin ?? null }));
  }
};

export const clearAuthSession = (navigate) => {
  localStorage.removeItem('authToken');
  localStorage.removeItem('authAdmin');
  clearActiveCompany();
  clearCompanyCache();
  broadcastAdminUpdate(null);

  if (navigate) {
    navigate('/login', { replace: true });
    return;
  }

  if (typeof window !== 'undefined') {
    window.location.replace('/login');
  }
};

const cleanupAuth = (navigate) => {
  clearAuthSession(navigate);
};

export const apiRequest = async (path, options = {}, navigate) => {
  const {
    method = 'GET',
    body,
    headers = {},
    skipAuthRedirect = false,
  } = options;
  const token = localStorage.getItem('authToken');
  const activeCompanyId = getActiveCompanyId();

  const finalHeaders = { ...headers };
  if (token) {
    finalHeaders.Authorization = `Bearer ${token}`;
  }

  if (activeCompanyId) {
    finalHeaders['x-company-id'] = activeCompanyId;
  }

  let requestBody = body;
  if (body instanceof FormData) {
    // Let the browser add the multipart boundary; a caller-provided JSON header breaks uploads.
    delete finalHeaders['Content-Type'];
    delete finalHeaders['content-type'];
  } else if (body) {
    requestBody = JSON.stringify(body);
    if (!finalHeaders['Content-Type']) {
      finalHeaders['Content-Type'] = 'application/json';
    }
  }

  const response = await fetch(`${API_BASE_URL}${path}`, {
    method,
    headers: finalHeaders,
    body: requestBody,
  });

  let result = null;
  try {
    result = await response.json();
  } catch (error) {
    result = null;
  }

  if (response.status === 401) {
    if (!skipAuthRedirect) {
      cleanupAuth(navigate);
    }
    throw new Error(result?.message || 'Your session has expired. Please login again.');
  }

  if (!response.ok || result?.status !== 'SUCCESS') {
    throw new Error(result?.message || 'Failed to process request.');
  }

  return {
    data: result?.data ?? null,
    message: result?.message ?? '',
    meta: result?.meta ?? null,
  };
};
